import React, { Suspense } from 'react';
const LazyDashboard = React.lazy(() => import('../Dashboard/pages/default'));
// import DefaultDashboard from "./pages/default";

const Dashboard = (props) => {
  document.title = "Dashboard | TELKOMSEL";
  return (
    <Suspense fallback={<div>Loading Dashboard...</div>}>
      <LazyDashboard clientId={JSON.parse(sessionStorage.getItem("authUser")).data.clientId} props={props} />;
    </Suspense>
  )
};

export default Dashboard;
